<template>
  <div>
    <h1>Email Verification</h1>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
    name: `ValidateEmail`,
    data(){
        return{

        }
    },
    computed:{
        ...mapState("user", ["emailAnswer"]),
    },

async onMounted() {
    const token = this.$route.params.token
    if (token) {
        await this.$store.dispatch(`/user/fetchEmailAnswer`, token)
        //console.log(this.emailAnswer)
            if (this.emailAnswer) {
            //console.log("SUCCESSFUL EMAIL", this.emailAnswer)
            }else {
            //console.log("ERROR EMAIL ", this.emailAnswer)
            }
        }
    }
}
</script>